import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'comm-neighbor-invite-register-info-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h1>{{ title | translate }}</h1>
    <p class="font-semi-bold text-md mb-40 mt-8 leading-normal">{{ description | translate }}</p>

    <tsq-button
      schema="new-primary"
      size="lg"
      route="/login"
      [text]="'INVITE_NEIGHBORS_REGISTER.BACK_TO_LOGIN' | translate"
    />
  `,
})
export class InfoCardComponent {
  @Input() title: string;
  @Input() description: string;
}
